import React, { Component, Fragment } from 'react';
import { Tree } from 'antd';
const { TreeNode } = Tree;

class PathTree extends Component {
	constructor(props) {
        super(props);
        this.renderTree = this.renderTree.bind(this);
    }

  	render() {     
        const { foldersSelected } = this.props;        
    	return (
            <Fragment>
                <h5>Ejemplo de la organización de carpetas</h5>
                {`${foldersSelected.map(f => f.pathName).join('/')}`}
                <div className="line" style={{margin:'10px 0'}}></div>
                <Tree  autoExpandParent={true} defaultExpandAll={true} >
                    {this.renderTree()}
                </Tree>
                
            </Fragment>
    	);
    }  

    renderTree(index = -1) { 
        const { foldersSelected } = this.props;        
        if(index < foldersSelected.length - 1){
            let item = foldersSelected[index + 1];
            return (
                <TreeNode isL title={item.label} key={index} >
                    { this.renderTree(index + 1) }                                  
                </TreeNode>
            )
        }
    }    
}


export default PathTree;
